module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","receipt":"Beleg"},"en":{"back":"Back","receipt":"Receipt"}}')
  delete Component.options._Ctor
}
